import { BrandVariants, FluentProvider, FluentProviderProps, Theme, createLightTheme } from '@fluentui/react-components';

// Created from https://react.fluentui.dev/?path=/docs/theme-theme-designer--page with dynamics primary blue #2266e3
const dfpThemeBaseV9: BrandVariants = {
	10: '#020206',
	20: '#131627',
	30: '#1A2345',
	40: '#1F2E5F',
	50: '#223A7A',
	60: '#244696',
	70: '#2552B4',
	80: '#245FD2',
	90: '#376CE5',
	100: '#577AE8',
	110: '#7088EB',
	120: '#8597EE',
	130: '#99A6F1',
	140: '#ADB5F4',
	150: '#BFC5F7',
	160: '#D1D4FA',
};

export const dfpThemeV9: Theme = {
	...createLightTheme(dfpThemeBaseV9),
};

export const DfpFluentProvider = (props: FluentProviderProps) => {
	return (
		<FluentProvider theme={dfpThemeV9} {...props}>
			{props.children}
		</FluentProvider>
	);
};
